import { v4 as uuid } from "uuid";

export const generateUniqId = (): string => uuid();
